import { State } from "../state/state";

export const getAPIErrors = (state: State) => state.global.APIErrors; 